import React from 'react';

const Quote = () => (
  <blockquote className="quote">
    <p className="quote-text">
      Mathematics is not about numbers, equations, computations, or
      algorithms: it is about understanding.
      <span className="quote-name"> -- William Paul Thurston</span>
    </p>
  </blockquote>
);

export default Quote;
